module.exports = __webpack_public_path__ + "static/phone-form-1568c16744a57692c81f43aa152e6d3a.png";